import { useState } from 'react';
import SectionHeading from './SectionHeading';
import { films, filmCategories } from '@/mocks/mikami/films';

export default function FilmsSection() {
  const [active, setActive] = useState('all');
  const list = active === 'all' ? films : films.filter((film) => film.category === active);

  return (
    <section id="films" className="anchor-offset bg-background-100 py-14 md:py-20">
      <div className="px-4 md:px-8">
        <SectionHeading
          eyebrow="新片速览"
          title="按题材浏览近期新片方向"
          description="下方条目按剧情向、影像向、合作企划与纪念企划分类。切换标签即可筛选，每条都标注了题材、时长方向与主要看点，方便先判断是否符合偏好。"
        />

        <div className="mb-6 flex flex-wrap gap-2 rounded-full border border-background-200 bg-background-50 px-2 py-2">
          {filmCategories.map((cat) => {
            const isActive = cat.id === active;
            return (
              <button
                key={cat.id}
                type="button"
                onClick={() => setActive(cat.id)}
                aria-pressed={isActive}
                className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-label transition-colors ${
                  isActive
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:bg-primary-100 hover:text-primary-700'
                }`}
              >
                {cat.label}
              </button>
            );
          })}
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((film) => (
            <article
              key={film.id}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center justify-between gap-3">
                <span className="rounded-full bg-primary-100 px-2.5 py-0.5 text-xs font-label text-primary-700">
                  {film.categoryLabel}
                </span>
                <span className="text-xs text-foreground-500">{film.period}</span>
              </div>
              <h3 className="mt-3 font-heading text-base font-bold text-foreground-950 md:text-lg">{film.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{film.summary}</p>
              <p className="mt-3 rounded-md bg-accent-50 px-3 py-2 text-xs leading-relaxed text-accent-800">
                <i className="ri-lightbulb-line mr-1"></i>
                {film.highlight}
              </p>
              <div className="mt-4 flex flex-wrap items-center gap-2 border-t border-background-200 pt-3">
                <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-time-line"></i>
                  {film.duration}
                </span>
                {film.tags.map((tag) => (
                  <span key={tag} className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs font-label text-secondary-900">
                    {tag}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}